import {CTABanner, Section} from '@primer/react-brand/esm'

import {useGenericCtaAction} from '../../../../brand/components/GenericCtaAction/use-generic-cta-action'

import type {PricingCustomerStoryContent} from '../../content'

import styles from './CustomerStorySection.module.css'

type Props = {
  content: PricingCustomerStoryContent
}

export function CustomerStorySection({content}: Props) {
  const {story, image, cta} = content
  const primary = useGenericCtaAction(cta?.primary, {
    analytics: {tag: 'button', context: 'CTAs', location: 'pricing_customer_story'},
    variant: 'primary',
  })
  const secondary = useGenericCtaAction(cta?.secondary, {
    analytics: {tag: 'button', context: 'CTAs', location: 'pricing_customer_story'},
    variant: 'secondary',
  })
  const asset = image?.fields.asset
  const dimensions = asset?.fields.file.details?.image

  return (
    <Section
      as="div"
      id={story.fields.htmlId}
      className={styles.CustomerStory}
      fullWidth
      paddingBlockStart="none"
      paddingBlockEnd="none"
    >
      <CTABanner variant={asset ? 'balanced' : 'default'} hasGridLines>
        <CTABanner.Heading as="h2" size="4">
          {story.fields.heading}
        </CTABanner.Heading>

        {cta && (
          <CTABanner.ButtonGroup>
            {primary.action}
            {secondary.action}
          </CTABanner.ButtonGroup>
        )}

        {asset && (
          <CTABanner.Image
            src={`${asset.fields.file.url}?fm=webp&w=960`}
            alt={image?.fields.description ?? asset.fields.description ?? ''}
            width={dimensions?.width}
            height={dimensions?.height}
            loading="lazy"
          />
        )}
      </CTABanner>

      {primary.feedback}
      {secondary.feedback}
    </Section>
  )
}
